import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { NotificationResultModel } from "./notification-result.model";

export namespace NotificationResultAction {
	const ACTION_PREFIX = "[Notification Result]";

	export const set = createAction(`${ACTION_PREFIX} Set`, (model: NotificationResultModel) => ({ model }));

	export const setSuccess = createAction(`${ACTION_PREFIX} Set Success`);

	export const setFail = createAction(`${ACTION_PREFIX} Set Fail`, (error: AppError) => ({ error }));
}
